import type { Plugin } from "vue";
import { init } from "@sentry/vue";
import { serverApiUrl } from "ls/api/urls";

export const SENTRY_GLOBALS = {
  release: globalThis.SENTRY_RELEASE?.id,
  enabled: import.meta.env.PROD,
  environment: import.meta.env.MODE,
  tunnel: new URL("tunnel", serverApiUrl).toString(),
  dsn: "https://15214c4a64bc8dcc8ac5f1f438dedd8b@o128192.ingest.sentry.io/4506537549299712",
  debug: false,
};

export const sentry: Plugin = {
  install(app) {
    init({
      app,
      debug: SENTRY_GLOBALS.debug,
      enabled: SENTRY_GLOBALS.enabled,
      environment: SENTRY_GLOBALS.environment,
      dsn: SENTRY_GLOBALS.dsn,
      tunnel: SENTRY_GLOBALS.tunnel,
      integrations: [],
    });
  },
};
